<ng-template [ngIf]="!reported">
	<form [formGroup]="fraudulentFurndraiserForm">
		<div
			*ngIf="!this.isLoading"
			ngClass="p-xxl"
			ngClass.sm="p-m"
			ngClass.xs="p-s"
			fxFlex="100%"
			fxLayout="row"
			fxLayoutAlign="start start"
			fxLayoutGap="5%"
		>
			<div
				fxFlex="100%"
				fxFlex.sm="65%"
				fxFlex.xs="90%"
				fxLayout="column"
				fxLayoutAlign="start start"
				fxLayoutGap="3%"
			>
				<div fxFill fxLayout="column" fxLayoutAlign="start start ">
					<h1
						class="mat-h1 mat-typography"
						i18n="@@reportProblem_heading_label"
					>
						Report a problem
					</h1>
					<div ngClass.lt-sm="w-100" ngClass="w-50">
						<!-- Full Name -->
						<mat-form-field class="w-100" appearance="outline">
							<mat-label i18n="@@fullName_label">Full Name</mat-label>
							<input
								required
								matInput
								placeholder="{{ fradulentFullname }}"
								formControlName="fullName"
								#fullName
							/>
							<mat-error
								i18n="@@fraudulent_formField_matError_mustBeBetween1to200"
								*ngIf="fraudulentFurndraiserForm.controls['fullName'].errors"
							>
								Must be between 1 to 200 characters
							</mat-error>
							<mat-error
								i18n="@@registration_formField_matError_mustBealphabets"
								*ngIf="
									fraudulentFurndraiserForm.controls['fullName'].errors &&
									fraudulentFurndraiserForm.controls['fullName'].errors.pattern
								"
							>
								Must be alphabets only
							</mat-error>
						</mat-form-field>
						<mat-form-field class="w-100" appearance="outline">
							<mat-label i18n="@@account_components_register_form_email_label"
								>Email Address</mat-label
							>
							<input
								required
								matInput
								placeholder="{{ fradulentEmail }}"
								formControlName="email"
								type="email"
								#email
							/>
							<mat-error
								*ngIf="fraudulentFurndraiserForm.controls['email'].invalid"
							>
								{{ getErrorMessage() }}
							</mat-error>
						</mat-form-field>
						<mat-form-field class="w-100 p-b-s" appearance="outline">
							<mat-label i18n="@@describe_the_reason"
								>Describe the reason</mat-label
							>
							<textarea
								required
								matInput
								formControlName="reason"
								cdkTextareaAutosize
								cdkAutosizeMinRows="5"
								cdkAutosizeMaxRows="8"
								id="reason"
								maxlength="150"
								#reason
								placeholder="{{ fradulentReason }}"
							></textarea>
							<mat-hint align="end"
								>{{ reason.value.length }} / 150
								<span i18n="@@characters_translation">Characters</span>
							</mat-hint>
							<mat-error
								i18n="@@fraudulent_formField_matError_mustBeBetween1to150"
								*ngIf="fraudulentFurndraiserForm.controls['reason'].errors"
							>
								Must be between 1 to 150 characters
							</mat-error>
						</mat-form-field>
						<div fxLayout="column" fxLayoutGap="4%">
							<button
								mat-flat-button
								color="accent"
								id="save"
								type="submit"
								class="w-100"
								(click)="this.saveFundraiser()"
								[disabled]="!fraudulentFurndraiserForm.valid"
							>
								<span i18n="@@button_save">Save</span>
							</button>
							<button
								mat-stroked-button
								color="accent"
								type="button"
								class="w-100"
								(click)="backToFundraiser()"
								i18n="@@button_cancel"
							>
								Cancel
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</form>
</ng-template>
<ng-template [ngIf]="reported">
	<div
		*ngIf="!this.isLoading"
		ngClass="p-xxl"
		ngClass.sm="p-xl"
		ngClass.xs="p-xl"
		fxFlex="100%"
		fxFill
		fxLayout="column"
		fxLayoutAlign="center center"
		fxLayoutGap="2%"
	>
		<h2 class="mat-typography">
			<img
				height="16px"
				src="https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/checkCircleBlue/public"
			/>
			<span i18n="@@fraudulent_thanks_label"
				>Thanks for reporting this fundraiser</span
			>
		</h2>
		<p
			style="max-width: 380px"
			class="mat-typography"
			i18n="@@fraudulent_thanks_content"
		>
			We will review the fundraiser to determine whether it voilates our
			guidlines. Thanks for helping us keep the platform safe
		</p>
		<button
			mat-flat-button
			color="accent"
			(click)="backToFundraiser()"
			i18n="@@button_goTofundraiserPage"
		>
			Back To Fundraiser Page
		</button>
	</div>
</ng-template>
<ng-template [ngIf]="marked">
	<div
		*ngIf="!this.isLoading"
		ngClass="p-xxl"
		ngClass.sm="p-xl"
		ngClass.xs="p-xl"
		fxFlex="100%"
		fxFill
		fxLayout="column"
		fxLayoutAlign="center center"
		fxLayoutGap="2%"
	>
		<h2 class="mat-typography">
			<img
				height="16px"
				src="https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/cancelCloseFilled/public"
			/>
			<span i18n="@@fraudulent_cannot_report_label"
				>You cannot report this fundraiser</span
			>
		</h2>
		<p
			style="max-width: 380px"
			class="mat-typography"
			i18n="@@fraudulent_cannot_report_content"
		>
			Your request to report this fundraiser is currently with out team. We will
			get back to you shortly.
		</p>
		<button
			mat-flat-button
			color="accent"
			(click)="backToFundraiser()"
			i18n="@@button_goTofundraiserPage"
		>
			Back To Fundraiser Page
		</button>
	</div>
</ng-template>
